import React from 'react';
export function Footer() {
  return <footer className="defer-paint w-full bg-pine-dark py-12 pb-28 sm:pb-12" data-id="element-91" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-92" data-mp="3ggaqtvj9sd5g">
        <p className="font-display text-2xl font-bold uppercase tracking-[0.08em] text-paper-soft" data-id="element-93" data-mp="32nulup6t651w">
          Pallamano 360™
        </p>
        <p className="mt-3 font-sans text-sm text-pine-light" data-id="element-94" data-mp="36qhhl16loa4d">
          Guarda il gesto. Organizza il campo. Guida l'allenamento.
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-paper-soft/30" aria-hidden="true" data-id="element-95" data-mp="3ucxmluzhkx9s" />
        <p className="mt-6 font-sans text-xs leading-relaxed text-pine-light" data-id="element-96" data-mp="37xxily2sakn">
          © 2026 PALLAMANO 360™ — Tutti i diritti riservati.
        </p>
        <p className="mx-auto mt-2 max-w-xl font-sans text-xs leading-relaxed text-pine-light/80" data-id="element-97" data-mp="3qcx9cdo4is4b">
          Sistema digitale di supporto alla pianificazione per allenatori di
          pallamano. I risultati dipendono dal contesto, dal livello degli
          atleti e da come il materiale viene applicato negli allenamenti
          reali.
        </p>
      </div>
    </footer>;
}